import { Fragment } from "./node";
import { Destroyable } from "../core/destroyable";
import { Signal } from "../core/signal";
import { Slot } from "../core/slot";
/**
 * Interceptor is designed to connect signals & methods of children elements
 * @class Interceptor
 * @extends Destroyable
 */
export class Interceptor extends Destroyable {
    constructor() {
        super(...arguments);
        /**
         * Set of signals
         * @type Set
         */
        this.signals = new Set;
        /**
         * Set of handlers
         * @type Set
         */
        this.handlers = new Set;
    }
    /**
     * Connect a signal or a handler
     * @param thing {Signal | function}
     */
    connect(thing) {
        // interceptor will connect signals and handlers together
        if (thing instanceof Signal) {
            this.handlers.forEach(handler => {
                thing.subscribe(handler);
            });
            this.signals.add(thing);
        }
        else {
            this.signals.forEach(signal => {
                signal.subscribe(thing);
            });
            this.handlers.add(thing);
        }
    }
    /**
     * Disconnect a handler from signals
     * @param handler {function}
     */
    disconnect(handler) {
        this.signals.forEach(signal => {
            signal.unsubscribe(handler);
        });
    }
    $destroy() {
        super.$destroy();
        this.signals.forEach(signal => {
            this.handlers.forEach(handler => {
                signal.unsubscribe(handler);
            });
        });
    }
}
/**
 * Interceptor node to implement directly to vasille DOM
 * @class InterceptorNode
 * @extends Extension
 */
export class InterceptorNode extends Fragment {
    constructor() {
        super(...arguments);
        /**
         * Internal interceptor
         * @type Interceptor
         */
        this.interceptor = new Interceptor;
        /**
         * The default slot of node
         * @type Slot
         */
        this.slot = new Slot;
    }
    $compose() {
        this.slot.release(this, this.interceptor);
    }
}
